// frontend/src/services/socket.js
import { io } from 'socket.io-client';
import config from '../config/config';

const socket = io(config.SOCKET_URL, {
  autoConnect: false,
  transports: ['websocket', 'polling']
});

// Connection event handlers
socket.on('connect', () => {
  console.log('✓ Socket connected:', socket.id);
});

socket.on('disconnect', (reason) => {
  console.log('✗ Socket disconnected:', reason);
});

socket.on('connect_error', (error) => {
  console.error('Socket connection error:', error);
});

export default socket;
